module.exports = __webpack_public_path__ + "img/symphony.1e8b0f2b.png";